import React from "react";

export const AgentShowcase = ({ data, onOpenPage }) => {
  if (!data) return null;

  const openDetail = (event) => {
    if (!onOpenPage) return;
    event.preventDefault();
    onOpenPage("agent-platform");
  };

  return (
    <section id="agents" className="agent-showcase">
      <div className="container">
        <div className="agent-intro-grid">
          <div className="agent-intro-copy">
            <span className="agent-eyebrow">{data.eyebrow}</span>
            <h2>{data.headline}</h2>
            <p>{data.subhead}</p>
            <div className="agent-actions">
              <a
                href="#/agent-platform"
                className="agent-primary-link"
                onClick={openDetail}
              >
                Explore Agent Platform
                <i className="fa fa-arrow-right" />
              </a>
              <a href="#contact" className="agent-secondary-link page-scroll">
                Discuss a Use Case
              </a>
            </div>
          </div>

          <div className="agent-outcome-panel" aria-label="Agent operating loop">
            <div className="agent-outcome-head">
              <span>FROM INTENT TO OUTCOME</span>
              <strong>One coordinated agent operating loop</strong>
            </div>
            <div className="agent-outcome-flow">
              {(data.operatingLoop || []).map((item, index) => (
                <React.Fragment key={item.title}>
                  <div className="agent-outcome-step">
                    <i className={item.icon} />
                    <span>{item.title}</span>
                  </div>
                  {index < data.operatingLoop.length - 1 && (
                    <i className="fa fa-long-arrow-right agent-flow-arrow" />
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>

        <div className="agent-use-case-grid">
          {(data.useCases || []).map((item, index) => (
            <article className="agent-use-case" key={item.title}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <i className={item.icon} />
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>

        <div className="agent-foundation" aria-label="GOLDLY AI platform layers">
          {(data.layers || []).map((layer, index) => (
            <React.Fragment key={layer.title}>
              <div className={`agent-layer agent-layer-${index + 1}`}>
                <span>{layer.kicker}</span>
                <strong>{layer.title}</strong>
                <p>{layer.text}</p>
              </div>
              {index < data.layers.length - 1 && (
                <i className="fa fa-plus agent-layer-plus" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};
